/** Escape text for safe use inside HTML tooltips (tippy allowHTML). */
export function escapeHtml(str) {
  if (str == null || str === '') return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

const trimStr = (v) => (v == null ? '' : String(v).trim());

/**
 * Lines to show for room: always sala (name or placeholder), optional lokalizacja i uwagi.
 */
export function roomDetailLines(roomName, location, comment) {
  const name = trimStr(roomName);
  const loc = trimStr(location);
  const com = trimStr(comment);
  const lines = [{ label: 'Sala', value: name || '—' }];
  if (loc) lines.push({ label: 'Lokalizacja', value: loc });
  if (com) lines.push({ label: 'Uwagi sali', value: com });
  return lines;
}

/** HTML fragment for calendar tooltips (newline = <br/>). */
export function roomTooltipHtml(roomName, location, comment) {
  return roomDetailLines(roomName, location, comment)
    .map(
      (p) =>
        `<strong>${escapeHtml(p.label)}:</strong> ${escapeHtml(p.value)}`
    )
    .join('<br/>');
}
